import React, {useEffect, useState} from 'react';
import {DateTime} from "luxon";
import Fade from "@mui/material/Fade";

const TimelineCurrentTimeMarker = (props) => {

    let [currentTime, setCurrentTime] = useState(null);
    let [markerTop, setMarkerTop] = useState(133);
    let [transitionSpeed, setTransitionSpeed] = useState(null);

    let lastTick = DateTime.local().startOf('day');

    useEffect(() => {
        const interval = setInterval(() => { onInterval(); }, 1000);
        return () => {
            clearInterval(interval)
        }
    }, [])

    // Set a slower marker transition when a timer update moves the marker
    useEffect(() => {
        setTransitionSpeed(0.5);
        handleTimeMarkerUpdate(props.nextRowDetails);
    }, [props.nextRowDetails])

    // Set a faster marker transition when we're scrolling the container
    useEffect(() => {
        setTransitionSpeed(0.01);
        handleTimeMarkerUpdate(props.nextRowDetails);
    }, [props.containerScrollTop])

    const onInterval = () => {
        let now = DateTime.local();
        setCurrentTime(now);

        if (!lastTick.hasSame(now, 'minute')) {
            props.onTick(now);
            lastTick = now;
        }
    }

    const getCurrentFormattedTime = (time) => {
        return time.toFormat('H:mm') // 24hr date without 2 char padding on hour
    }

    /**
     * @param {array} nextRowDetails
     */
    const handleTimeMarkerUpdate = (nextRowDetails) => {
        let newOffset = getMarkerOffset(nextRowDetails)
        setMarkerTop(newOffset)
    }

    const getMarkerOffset = (nextRowDetails) => {
        let $tableContainer = props.containerRef.current;

        if (!$tableContainer) {
            return 0;
        }

        let belowRow = false;

        let {row, index, isCurrentDay} = nextRowDetails;

        let headerHeight = (props.hasFilterRow) ? 83 : 40

        if (!row) {
            return 44;
        }

        if (!index) {
            belowRow = true;
        }

        let $row = document.getElementById(`row-${row.id}`);

        if (!$row) {
            return 44;
        }

        let newOffset = 0 - $tableContainer.scrollTop + $row.offsetTop;

        if (belowRow) {
            newOffset += $row.clientHeight;
        } else if (!isCurrentDay) {
            newOffset -= 27; // Move back by height of date header row
        }

        if (newOffset < headerHeight) {
            newOffset = headerHeight;
        }

        if (newOffset > $tableContainer.clientHeight) {
            newOffset = $tableContainer.clientHeight;
        }

        return newOffset;
    }

    const shouldShow = () => {
        if ((!currentTime || !markerTop)) {
            return false;
        }

        if (!props.nextRowDetails || !props.nextRowDetails.row) {
            return false;
        }

        return true;
    }

    if ((!currentTime || !markerTop)) {
        return null;
    }

    return (<>
        <Fade in={shouldShow()}>
            <div className="timeline-marker"
                 style={{
                     top: markerTop,
                     transition: `top ${transitionSpeed}s ease-out`
                 }}
            >
                <i className="fa fa-circle"/>
                <div>{getCurrentFormattedTime(currentTime)}</div>
            </div>
        </Fade>
    </>);
}

export default TimelineCurrentTimeMarker;
